import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * EmployeeRoute - Protected route component for employee pages
 * Checks if employee is logged in before allowing access
 */
export default function EmployeeRoute({ children }) {
  const employeeToken = localStorage.getItem('employee_token');
  const employeeId = localStorage.getItem('employee_id');

  // If not logged in, redirect to employee login
  if (!employeeToken || !employeeId) {
    return <Navigate to="/employee/login" replace />;
  }

  // If logged in, render the protected component
  return children;
}
